<div
  class="d-flex flex-row flex-wrap"
  cdkMonitorSubtreeFocus
  (cdkFocusChange)="focusChange($event)"
>
  @for (config of units(); track $index) {
    @if (!$first) {
      <ng-container *ngTemplateOutlet="separator; context: { separator: config.separator }" />
    }
    <label>
      @if (!hideLabels()) {
        <span class="form-label">{{ (config.label | translate) || '&nbsp;' }}</span>
      }
      <input
        #inputPart
        autocomplete="off"
        class="form-control hide-feedback-icon"
        type="text"
        inputmode="numeric"
        [attr.aria-label]="config.ariaLabel | translate"
        [attr.aria-describedby]="errormessageId()"
        [attr.maxlength]="config.maxLength"
        [formControl]="timeControls.controls[config.name]"
        [name]="config.name"
        [placeholder]="config.placeholder"
        [readonly]="readonly()"
        (blur)="updateField(config.name, toHtmlInputElement($event.target).value)"
        (keydown)="handleKeyPressEvent($event)"
      />
    </label>
  }
  @if (use12HourClock()) {
    <label class="ms-2">
      @if (!hideLabels()) {
        <span class="form-label">{{ (meridiansLabel() | translate) || '&nbsp;' }}</span>
      }
      <select
        #inputPart
        class="form-control"
        [attr.aria-label]="meridiansAriaLabel() | translate"
        [attr.aria-describedby]="errormessageId()"
        [class.readonly]="readonly()"
        [disabled]="disabled()"
        (change)="toggleMeridian()"
        (keydown)="handleKeyPressEvent($event)"
      >
        <option value="am" [selected]="meridian() === 'am'">{{ periods()[0] }}</option>
        <option value="pm" [selected]="meridian() === 'pm'">{{ periods()[1] }}</option>
      </select>
    </label>
  }
</div>

<ng-template #separator let-separator="separator">
  <div class="align-self-end pb-3 px-1" aria-hidden="true">{{ separator ? separator : ':' }}</div>
</ng-template>
